/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck

import React from 'react';
import { VisibilityContext } from 'react-horizontal-scrolling-menu';
import { ChevronRightIcon, ChevronLeftIcon } from '@heroicons/react/solid';
import { useBreakpoint } from '@vlinder-web/breakpoint-hook-widget-react';

function ArrowRight({
  children,
  disabled,
  onClick,
}: {
  children: React.ReactNode;
  disabled: boolean;
  onClick: VoidFunction;
}) {
  const breakpoint = useBreakpoint();
  const _getHeight = () => {
    let _style: any = {
      height: 50,
    };
    if (breakpoint === 'xs' || breakpoint === 'sm') {
      _style.height = 20;
    }
    return _style;
  };

  return (
    <ChevronRightIcon
      height={_getHeight().height}
      disabled={disabled}
      onClick={onClick}
      size={600}
      style={{
        cursor: 'pointer',
        //  height:"25px",
        alignSelf: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        right: '1%',
        opacity: disabled ? '0' : '1',
        userSelect: 'none',
      }}
    />
  );
}

function ArrowLeft({
  children,
  disabled,
  onClick,
}: {
  children: React.ReactNode;
  disabled: boolean;
  onClick: VoidFunction;
}) {
  const breakpoint = useBreakpoint();
  const _getHeight = () => {
    let _style: any = {
      height: 50,
    };
    if (breakpoint === 'xs' || breakpoint === 'sm') {
      _style.height = 20;
    }
    return _style;
  };

  return (
    <ChevronLeftIcon
      height={_getHeight().height}
      disabled={disabled}
      onClick={onClick}
      size={600}
      style={{
        cursor: 'pointer',
        //  height:"25px",
        alignSelf: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        right: '1%',
        opacity: disabled ? '0' : '1',
        userSelect: 'none',
      }}
    />
  );
}

export function LeftArrow() {
  const {
    isFirstItemVisible,
    scrollPrev,
    visibleItemsWithoutSeparators,
    initComplete,
  } = React.useContext(VisibilityContext);

  const [disabled, setDisabled] = React.useState(
    !initComplete || (initComplete && isFirstItemVisible)
  );
  React.useEffect(() => {
    if (visibleItemsWithoutSeparators.length) {
      setDisabled(isFirstItemVisible);
    }
  }, [isFirstItemVisible, visibleItemsWithoutSeparators]);

  return (
    <ArrowLeft disabled={disabled} onClick={() => scrollPrev()}>
      {/* { `<` } */}
    </ArrowLeft>
  );
}

export function RightArrow() {
  const { isLastItemVisible, scrollNext, visibleItemsWithoutSeparators } =
    React.useContext(VisibilityContext);

  const [disabled, setDisabled] = React.useState(
    !visibleItemsWithoutSeparators.length && isLastItemVisible
  );

  React.useEffect(() => {
    if (visibleItemsWithoutSeparators.length) {
      setDisabled(isLastItemVisible);
    }
  }, [isLastItemVisible, visibleItemsWithoutSeparators]);

  return (
    <ArrowRight disabled={disabled} onClick={() => scrollNext()}>
      {/* {`>`} */}
    </ArrowRight>
  );
}
